import { createContext } from "react";
import type { MorphemeCardTabHost } from "#morpheme-card-tab-host";

/**
 * Allows a card to host its mnemonics navigation (the glyph plus one section per reading) in its
 * Mnemonics binder tab instead of a tab strip inside the mnemonics content.
 */
export const MorphemeMnemonicsTabHostContext = createContext<MorphemeCardTabHost | null>(null);
